import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './GroupItem.scss';
import AvatarImg from '../../assets/images/home/avatar@2x.png';

class GroupItem extends Component {
  render () {
    const { teamLevel } = this.props;
    return (
      <div className='groupItem'>
        {
          this.props.groupList.map((item, index) => {
            return <div key={index} className='group-item' onClick={() => (teamLevel === 1 || teamLevel === 2) && this.props.groupClickFuc(item.accountId)}>
            <div className='item-avatar'><img src={AvatarImg} alt='' /></div>
            <div className='item-con'>
              <div className='item-title'>
                <span className='item-title-name'>{item.name}</span>
                {/* <span className='item-title-tag'>合伙人</span> */}
                {item.status === 0 && <span className='item-title-tag status1'>正常</span>}
                {item.status === 1 && <span className='item-title-tag status2'>停用</span>}
              </div>
              <div className='item-mobile'>{item.mobile}</div>
              <div className='item-detail'>
                {teamLevel === 1 && <div>团队成员 <span>{item.subCount}人</span></div>}
                <div>加入日期 <span>{item.referrerTime}</span></div>
              </div>
            </div>
            {(teamLevel === 1 || teamLevel === 2) && <i className='iconfont icon-arrrow'></i>}
          </div>
          })
        }
      </div>
    )
  }
}

GroupItem.propTypes = {
  groupList: PropTypes.array.isRequired,
  groupClickFuc: PropTypes.func,
  teamLevel: PropTypes.number
}

export default GroupItem;